import equal from 'deep-equal';
import get from 'lodash.get';
import { fabric } from 'fabric';
import { fabricbrush } from '@/utils/fabric-brush';
import gifEncoder from 'gif.js';
import gifWorker from 'raw-loader!gif.js/dist/gif.worker.js';

// import RgbQuant from "@/utils/GIFter/lib/rgbquant.js"
// import omggif from "@/utils/GIFter/lib/omggif.js"
// import b64 from "@/utils/GIFter/lib/b64.js"
// import "@/utils/GIFter/gifter.js"



//import { store } from './store/store';
import { sync } from 'vuex-pathify'
import canvasInit from './canvasInit';
import VueTimers from 'vue-timers';

export default {
   name: 'message-creator',
   //   mixins: [RgbQuant],
   props: {
      activeObjectId: null,
      namespace: {
         type: String,
         default: 'Canvas'
      },
      value: {
         type: Object,
         default() { return {}; }
      },
      width: {
         type: Number,
         default: 500
      },
      height: {
         type: Number,
         default: 500
      },
      messageReduction: {
         type: Number,
         default: 1
      },
      isVideoTimerActive: true,
      isDrawingMode: false,
      //drawColor: '#000000',
      drawColor: {
         type: String, // not 'string'
         default: '#000000'
      },
      drawBrush: {
         type: String, // not 'string'
         default: 'pencil'
      },
      drawSize: {
         type: Number, // not 'string'
         default: 10
      },
      backgroundImage: {
         type: String
      },
      watermark: {
         type: String
      },
      cameraCapture: {
         type: String
      }
   },
   data() {
      return {
         id: 'fabric_canvas',
         isUserInactive: true,
         cameraImages: [],
         messagesURL: [],
         canvasObject: null,
         watermarkObject: null,
         gifWorkerBlob: null,
         gifImage: null,
         framesCount: 0,
         isRecordingFrames: false,
         isObjDragging: false,
         canvasObjects: [],
         pathObjects: [],
         brushSettings: {
            pencil: {
               brushName: 'PencilBrush',
               settings: {

               }
            },
            spray: {
               brushName: 'SprayBrush',
               settings: {
                  randomOpacity: false,
               }

            },

         }
         //      id: `fabric_canvas_${this._uid}`
      }
   },
   timers: {
      changeCameraImage: { time: 200, autostart: false },
      changeCameraImageWDelay: { time: 1500, autostart: false },
   },
   mounted() {
      // var gifImage = new gifEncoder({
      //   workers: 2,
      //   quality: 10
      // });
      // gifImage.on('finished', function(blob) {
      //    window.open(URL.createObjectURL(blob));
      // });
      //var blob;
      try {
         this.gifWorkerBlob = new Blob([gifWorker], {
            type: 'application/javascript'
         });
         //console.log(gifWorker);
      } catch(e) { // Backwards-compatibility
         window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder;
         this.gifWorkerBlob = new BlobBuilder();
         this.gifWorkerBlob.append(response);
         this.gifWorkerBlob = this.gifWorkerBlob.getBlob();
      }
      this.canvasObject = document.getElementById(this.id);


      canvasInit(this, this.namespace);
      //this.$canvas.setBackgroundImage("http://placehold.it/500x200/448844/fff");
      //console.log(document.getElementById('fabric_canvas'))
      console.log(this.$canvas)
      console.log("watermark" + this.watermark)

      this.addWatermark();

      //    console.log(watermark)
      //    console.log(stickers[0].filename)
      //this.$nextTick(function () {
      let canvas = this.$canvas;
      let that = this;

      //            canvas.renderAll();


      //})

   },
   computed: {
      // @see https://davestewart.github.io/vuex-pathify/#/api/component
      app_state: sync('app_state'),
      is_in_app: sync('is_in_app'),
      is_retina: sync('is_retina'),
      pause_gif_enable: sync('pause_gif_enable'),
      os: sync('os'),
      message_width: sync('message_width'),
      message_height: sync('message_height'),
      menuScale: sync('menuScale'),
      messageDataURL: sync('messageDataURL'),
      // is_dev_mode:sync('is_dev_mode'),
      // host_address:sync('host_address'),
      // api_address:sync('api_address'),
      // token:sync('token'),
      //watermark: sync('settings@watermark'),
      //...sync('theme/*'),
      log: function () {
         // `this` pointe sur l'instance vm
         //console.log(get('thiswatermark)
      }

      //console.log(watermark)

      //  todos: {
      //  ...sync("todo/todo")
      //},

   },

   watch: {
      activeObjectId(newActiveObjectId) {
         let activeObject = this.$canvas.getObjects().find((obj) => {
            return obj._uid === newActiveObjectId;
         });
         if(newActiveObjectId && activeObject)
         this.$canvas.setActiveObject(activeObject);
      },
      /*
      * Watches when the object representation of the canvas is changed.
      *
      * It checks if the current canvas and the new mutation are the same,
      * in that case, it doesn't change anything; otherwise, it reloads
      * the whole canvas.
      *
      * Also makes sure that the active object is always up to date.
      */
      value: {
         handler(val, old) {
            if( !equal(this.$canvas.toObject(), val) ) {
               this.$canvas.loadFromJSON( val, this.load );
            }
         },
         deep: true
      },
      isVideoTimerActive: function (value, oldVal) {
         console.log("isVideoTimerActive " + value)
            if(value)
               this.playVideoTimerWithDelay();
            else
               this.pauseVideoTimer();
            //return value;
      },
      isDrawingMode: function(val, oldVal) {
         this.$canvas.isDrawingMode = val;
         console.log("isDrawingMode " + val)
         if (val == true) {
            this.$emit('enableUndo', false);
            this.pathObjects = [];
            var brushname = 'PencilBrush';
            if (this.brushSettings.hasOwnProperty(this.drawBrush) ) {
               brushname = this.brushSettings[this.drawBrush].brushName;
               console.log("brush name " + brushname);
            }
            else {
               console.log("default pencil brush");
            }
            this.$canvas.freeDrawingBrush = new fabric[brushname](this.$canvas);
            this.$canvas.freeDrawingBrush.width = this.drawSize;
            this.$canvas.freeDrawingBrush.color = this.drawColor;
            // assign settings to brush
            Object.assign(this.$canvas.freeDrawingBrush, this.brushSettings[this.drawBrush].settings)
            // switch (this.drawBrush) {
            //    case 'PencilBrush':
            //       break;
            //    case 'SprayBrush':
            //       this.$canvas.freeDrawingBrush.randomOpacity = true;
            //       break;
            // }
         }
         else
            this.groupPaths();
      },
      drawColor: function(val, oldVal) {
         console.log("drawColor " + val)
         this.$canvas.freeDrawingBrush.color = val;
      },
      drawSize: function(val, oldVal) {
         console.log("drawColor " + val)
         this.$canvas.freeDrawingBrush.width = val;
      }

   },
   methods: {
      /*
      * Loads and renders a canvas from an object representation of it.
      */
      load() {
         // Caches the currently active object if it still exists in the
         // new canvas.
         let oldActiveObject = this.$canvas.getObjects().find((obj) => {
            return obj._uid === this.activeObjectId;
         });

         this.$canvas.renderAll.call(this.$canvas);
         if(oldActiveObject)
         this.$canvas.setActiveObject(oldActiveObject);
      },
      /*
      * Emits an `input` event with the new object representation of the canvas.
      */
      syncCanvas() {
         let canvasObj = this.$canvas.toObject(),
         activeObjectId = get(this.$canvas.getActiveObject(), '_uid');
         //console.log("activeObjectId " + activeObjectId);

         this.$emit('input', {
            canvas: canvasObj,
            meta: {
               activeObjectId: activeObjectId
            }
         });
      },
      resetCanvas() {
         this.$timer.stop('changeCameraImage');
         this.$timer.stop('changeCameraImageWDelay');
         this.$canvas.clear();
         this.$canvas.setWidth(this.message_width);
         this.$canvas.setHeight(this.message_height);
         this.$canvas.freeDrawingBrush.width = this.drawSize;
         this.$canvas.freeDrawingBrush.color = this.drawColor;
         this.cameraImages = [];
         this.messagesURL = [];
         for(var i = 0; i < this.cameraImages.length; i++)
         {
            this.messagesURL.push('');
         }
         this.framesCount = 0;
         this.isRecordingFrames = false;
         this.currentCameraImage = 0;
         this.$timer.start('changeCameraImage');
      },
      changeCameraImage: function(e){
         this.$timer.stop('changeCameraImage');
         //this.$timer.stop('changeCameraImageWDelay');
         if (this.cameraImages.length > 1)
         {
            this.computeNextVideoFrame();
         }
         this.$timer.start('changeCameraImage');
      },
      playVideoTimer() {
         this.$timer.start('changeCameraImage');
      },
      changeCameraImageWDelay: function(e){
         this.$timer.stop('changeCameraImageWDelay');
         this.playVideoTimer();
      },
      playVideoTimerWithDelay() {
         if(this.pause_gif_enable) {
            this.$timer.stop('changeCameraImageWDelay');
            this.$timer.start('changeCameraImageWDelay');
         }
      },
      pauseVideoTimer() {
         if(this.pause_gif_enable) {
            this.$timer.stop('changeCameraImageWDelay');
            this.$timer.stop('changeCameraImage');
         }
      },
      computeNextVideoFrame() {
         for(var i = 0; i < this.cameraImages.length; i++)
         {
            if (i == this.currentCameraImage) {
               //this.cameraImages[i].opacity = 1;
               this.cameraImages[i].visible = true;
            }
            else {
               //this.cameraImages[i].opacity = 0;
               this.cameraImages[i].visible = false;
            }
         }
         this.$canvas.renderAll();
         this.currentCameraImage++;
         this.currentCameraImage = this.currentCameraImage%this.cameraImages.length;
      },
      toDataURL(){
         this.$timer.stop('changeCameraImageWDelay');
         this.$timer.stop('changeCameraImage');
         if(this.watermarkObject != null) {
            this.watermarkObject.visible = true;
            this.watermarkObject.bringToFront();
         }
         else
            console.log("no watermark loaded");
         if (this.cameraImages.length > 1)
         {
            console.log("Record Video");
            // this.messagesURL = [];
            // for(var i = 0; i < this.cameraImages.length; i++)
            // {
            //    this.messagesURL.push('');
            // }
            this.framesCount = 0;
            this.currentCameraImage = 0;
            this.isRecordingFrames = true;

            //**blob to dataURL**
            function blobToDataURL(blob, callback) {
               var a = new FileReader();
               a.onload = function(e) {callback(e.target.result);}
               a.readAsDataURL(blob);
            }



            var that = this;
            this.gifImage = new gifEncoder({
               workers: 2,
               workerScript: URL.createObjectURL(that.gifWorkerBlob),
               quality: 10
            });
            this.gifImage.on('progress', function(p) {
               //var percent = Math.round(p * 100)+'%';
               that.$emit('onGifCompute', p);

               //that.messageDataURL = URL.createObjectURL(blob);
               //console.log(that.messageDataURL);
               //gif.addFrame(this.canvasObject);

            });

            this.gifImage.on('finished', function(blob) {
               console.log("gif generated");
               //that.messageDataURL = URL.createObjectURL(blob);
               //console.log(that.messageDataURL);
               console.log("messageDataURL");

               blobToDataURL(blob, function(dataurl){
                  that.messageDataURL = dataurl;
                  console.log(dataurl);
                  that.gifImage.freeWorkers.forEach(w => w.terminate());
                  that.$emit('onGifReady');
               });

               //window.open(URL.createObjectURL(blob));
            });

            // start calculate gif
            for(var i = 0; i < this.cameraImages.length; i++)
            {
               this.computeNextVideoFrame();
               this.gifImage.addFrame(that.canvasObject, {copy: true, delay: 200});
            }
            that.gifImage.render();
            // // options
            // var width  = 1920,
            // 	height = 1080,
            // 	opts = {
            // 		loop: 0,
            // 		loopDelay:  0,
            // 		frameDelay: 200,
            // 	//	cropBox: [2,2,5,5],
            // 	};
            //
            // var gif = new GIFter(width, height, opts);

            // layer0 and layer1 are <img> and/or <canvas> elements
            //gif.addFrame(layer0);
            // multi-layer frame
            //gif.addFrame([layer0, layer1]);


            // this.gifImage.render();
            // execute encoder
            //var img = gif.render();
            //console.log("img");

            // lets see it!
            //document.body.appendChild(img);


         }
         return this.$canvas.toDataURL( {format: 'jpeg', quality:0.8, enableRetinaScaling: this.is_retina });

      },

      addCameraImage(filter = 'none') {
         // add camera image
         let canvas = this.$canvas;
         let that = this;
         if(this.cameraCapture != null)
         {
            var context = canvas.getContext('2d');
            context.filter = filter;
            fabric.Image.fromURL(this.cameraCapture, function(img) {
               var img_aspect = img.width / img.height; //Aspect ratio of image
               var mess_aspect = that.message_width / that.message_height; //Aspect ratio of message
               var scale = 1;
               var new_top = 0;
               var new_left = 0;

               if(img_aspect < mess_aspect)
               {
                  scale = that.message_width / img.width;
                  new_top = -(img.height * scale - that.message_height) * 0.5;
               } else {
                  scale = that.message_height / img.height ;
                  new_left = -(img.width * scale - that.message_width) * 0.5;
               }

               console.log( "camera x: " + new_left + " y: " + new_top + " w: " + img.width + " h: " + img.height + " scale: " + scale);

               img.set({
                  left: new_left,
                  top: new_top,
                  //width: that.message_width,
                  //height: that.message_height,
                  scaleX: -scale,
                  scaleY: scale,
                  // selectable: false,
                  evented:false,
                  hasControls: false,
                  lockMovementX: true,
                  lockMovementY: true,
                  lockScalingX: true,
                  lockScalingY: true,
                  lockUniScaling: true,
                  lockRotation: true
               });
               //img.hasControls = false;

               // //filter to adapt camera image resolution to screen size
               // if(that.is_in_app) {
               //    img.resizeFilter = new fabric.Image.filters.Resize({
               //       resizeType: 'sliceHack'
               //    });
               //    img.applyResizeFilters();
               // }

               switch (filter)
               {
                  case 'grayscale':
                  img.filters[0] = new fabric.Image.filters.Grayscale();
                  img.applyFilters(img.filters);
                  break;
                  case 'sepia':
                  img.filters[0] = new fabric.Image.filters.Sepia();
                  img.applyFilters(img.filters);
                  break;
                  case 'saturate':
                  //img.filters[0] = new fabric.Image.filters.Kodachrome();
                  img.filters[0] = new fabric.Image.filters.Saturation({  saturation:4 });
                  img.applyFilters(img.filters);
                  break;
                  case 'black_and_white':
                  img.filters[0] = new fabric.Image.filters.BlackWhite();
                  img.applyFilters(img.filters);
                  break;
               }

               canvas.add(img);
               that.cameraImages.push(img);
               console.log("Add camera capture to Canvas");
               console.log("Filter " + filter);
            });

         }
      },
      addBackgroundImage() {
         //backgroundImage
         let canvas = this.$canvas;
         let that = this;
         if(this.backgroundImage != null)
         {
            fabric.Image.fromURL(this.backgroundImage, function(img) {
               var img_aspect = img.width / img.height; //Aspect ratio of image
               var mess_aspect = that.message_width / that.message_height; //Aspect ratio of message
               var scale = 1;
               var new_top = 0;
               var new_left = 0;

               if(img_aspect < mess_aspect)
               {
                  scale = that.message_width / img.width;
                  new_top = -(img.height * scale - that.message_height) * 0.5;
               } else {
                  scale = that.message_height / img.height ;
                  new_left = -(img.width * scale - that.message_width) * 0.5;
               }

               console.log( "background x: " + new_left + " y: " + new_top + " w: " + img.width + " h: " + img.height + " scale: " + scale);

               //console.log("Add backgroundImage to Canvas")
               img.set({
                  left: new_left,
                  top: new_top,
                  //width: 1920,
                  //height: 1080,
                  // selectable: false,
                  scaleX: scale,
                  scaleY: scale,
                  evented:false,
                  hasControls: false,
                  lockMovementX: true,
                  lockMovementY: true,
                  lockScalingX: true,
                  lockScalingY: true,
                  lockUniScaling: true,
                  lockRotation: true

               });
               //img.crossOrigin = "Anonymous";  // This enables CORS
               //img.hasControls = false;
               //console.log(canvas)


               //filter to adapt camera image resolution to screen size
               if(that.is_in_app) {
                  img.resizeFilter = new fabric.Image.filters.Resize({
                     resizeType: 'sliceHack'
                  });
                  img.applyResizeFilters();
               }


               //var fabricCanvas = document.getElementById('fabric_canvas');
               canvas.add(img);
               console.log("Add backgroundImage to Canvas")
               //this.$canvas.renderAll();
            }, {
               crossOrigin: 'anonymous'
            });
         }
      },
      addWatermark() {
         //backgroundImage
         let canvas = this.$canvas;
         let that = this;
         if(this.watermark != null)
         {
            fabric.Image.fromURL(this.watermark, function(img) {
               var img_aspect = img.width / img.height; //Aspect ratio of image
               var mess_aspect = that.message_width / that.message_height; //Aspect ratio of message
               var scale = 1;
               var new_top = 0;
               var new_left = 0;

               if(img_aspect < mess_aspect)
               {
                  scale = that.message_width / img.width;
                  // align on bottom
                  new_top = -(img.height * scale - that.message_height); // * 0.5;
               } else {
                  scale = that.message_height / img.height ;
                  // align on right
                  new_left = -(img.width * scale - that.message_width); // * 0.5;
               }

               console.log( "watermark x: " + new_left + " y: " + new_top + " w: " + img.width + " h: " + img.height + " scale: " + scale);

               //console.log("Add backgroundImage to Canvas")
               img.set({
                  left: new_left,
                  top: new_top,
                  //width: 1920,
                  //height: 1080,
                  // selectable: false,
                  scaleX: scale,
                  scaleY: scale,
                  evented:false,
                  hasControls: false,
                  lockMovementX: true,
                  lockMovementY: true,
                  lockScalingX: true,
                  lockScalingY: true,
                  lockUniScaling: true,
                  lockRotation: true

               });
               //img.crossOrigin = "Anonymous";  // This enables CORS
               //img.hasControls = false;
               //console.log(canvas)
               //this.watermarkObject = img;
               //var fabricCanvas = document.getElementById('fabric_canvas');
               canvas.add(img);
               canvas.sendToBack(img);
               that.watermarkObject = img;
               img.visible = false;
               console.log("Add watermark to Canvas")
               //this.$canvas.renderAll();
            }, {
               crossOrigin: 'anonymous'
            });
         }
      },
      hideWatermark(){
         console.log("hide Watermark");
         this.$canvas.sendToBack(this.watermarkObject);
         this.watermarkObject.visible = false;
      },
      unselectActiveObject(){
         this.$canvas.discardActiveObject();
      },
      selectLast() {
         var canvas_objects = this.$canvas._objects;
         if(canvas_objects.length !== 0){
            var last = canvas_objects[canvas_objects.length -1]; //Get last object
            console.log("select last " + last.type);
            if(last.type !== "path" ) {
               this.$canvas.select(last);
            }
         }
      },
      undo() {

         //var canvas_objects = this.$canvas._objects;
         //var canvas_objects = this.canvasObjects;
         if(this.pathObjects.length !== 0){
            //            var last = canvas_objects[canvas_objects.length -1]; //Get last object
            var last =  this.pathObjects.pop(); //Get last object
            console.log("Undo Last created " + last.type);
            //this.delete(last);
            if(this.isDrawingMode || last.type === "path" || last.type === "group" ) {
               this.$canvas.remove(last);
               this.$canvas.renderAll();
               if(this.pathObjects.length == 0)
               this.$emit('enableUndo', false);
            }
         }
         //this.canvasObjects.remove(last)
      },
      deleteLast() {
         var canvas_objects = this.$canvas._objects;
         //console.log("delete")
         var onTop = this.$canvas.getActiveObject();
         this.delete(onTop);
      },
      delete(obj) {
         if(obj != null){
            console.log("delete " + obj.type);
            if(obj.type == "image") {
               obj.off("selected");
               obj.off("deselected");
               this.$canvas.remove(obj);
               this.$canvas.renderAll();
            }
            else if(obj.type == "group") {
               obj.off("selected");
               obj.off("deselected");
               var canv = this.$canvas;
               obj.forEachObject(function(a) {
                  canv.remove(a);
               });
               this.$canvas.remove(obj);
               this.$canvas.renderAll();
            }
            else if(obj.type == "textbox" ) {
               obj.off("added");
               obj.off("editing:entered");
               obj.off("editing:exited");
               obj.off("changed");
               obj.off("modified");
               obj.off("selected");
               obj.off("deselected");
               this.$canvas.remove(obj);
               this.$canvas.renderAll();
            }
         }
      },
      groupPaths() {
         var group = new fabric.Group(this.pathObjects, {
            hasBorders: false,
            hasControls: false,
            hasRotatingPoint: false,
            lockUniScaling: true,
            minScaleLimit:0.5

         });
         this.$canvas.setActiveObject(group);
         this.canvasObjects.push(group);
         this.$canvas.add(group);
         this.pathObjects = [];
         if(this.drawBrush != 'pencil') {
            group.objectCaching = false;
            group.statefullCache = true;
            group.noScaleCache = false;
         }
         var canv = this.$canvas;
         group.on(("mousedown"),function(){
            //console.log("image clicked " + this.isSelected);
            //this.canvas.renderAll();
            if (this.isSelected){
               this.isSelected = false;
               canv.discardActiveObject();
            }
         });
         group.on(("selected"),function(){
            //left = this.textBox.left;
            console.log("drawing selected");
            //this.canvas.renderAll();
            var that = this;
            var timeout = setTimeout(function(){
               that.isSelected = true;
            }, 10)
            this.bringToFront();
            this.perPixelTargetFind = false;
            //this.setShadow({ color: 'rgba(0,0,0,0.7)', blur: 50 });


         });
         group.on(("deselected"),function(){
            //left = this.textBox.left;
            console.log("drawing deselected");
            this.isSelected = false;
            //this.bringToFront();
            this.perPixelTargetFind = true;
            //this.setShadow({ color: 'rgba(0,0,0,0.', blur: 50 });
            this.canvas.renderAll();
         });

      },

      addText(text, color, font, x, y) {
         console.log("Add text")
         var textBox = new fabric.Textbox(text, {
            left: x,
            top: y,
            width: 850,
            originX: 'center',
            fontFamily: 'Univers Condensed',
            fontSize: font,
            textAlign: 'center',
            fill: color,
            MIN_TEXT_WIDTH: 20,
            editable: false,
            cursorWidth: 0,
            hasBorders: false,
            hasControls: false,
            hasRotatingPoint: false,
            lockUniScaling: true,
            minScaleLimit:0.5

         });

         this.$canvas.add(textBox);
         this.canvasObjects.push(textBox);
         this.$canvas.setActiveObject(textBox);
         textBox.isSelected = false;
         //this.$canvas.setActiveObject(this.$canvas.item(0));
         //textBox.enterEditing();
         //textBox.selectAll();

         // Resize textbox
         //canvas.setActiveObject(textBox);
         var actualWidth = textBox.scaleX * textBox.width;
         //var largest = textBox.__lineWidths[0];
         var largest = textBox._measureLine(0).width;
         console.log("largest " + largest);
         if (largest !== undefined )
         {
            var tryWidth = (largest + 50) * textBox.scaleX;
            textBox.set("width",tryWidth);
            //               this.canvas.getActiveObject().set("width",tryWidth);
         }
         if((textBox.left + actualWidth) >= this.$canvas.width - 10)
         {
            //console.log(canvas.height - arrowLeft)
            textBox.set("width", this.$canvas.width - 10)
         }
         console.log("textbox width " + textBox.width);
         this.$canvas.renderAll();



         var that = this;
         var canvas = this.$canvas;
         textBox.on('selected', function(e) {
            console.log(textBox);
            console.log('selected Textbox');
            this.canvas.renderAll();

         });

         textBox.on("added", function (e) {

            console.log("added text ");
            //canvas.setActiveObject(textBox);
            //             var largest = textBox.__lineWidths[0];
            //             console.log("added, largest " + largest);
            //             if (largest !== undefined )
            //             {
            //                var tryWidth = (largest + 30) * textBox.scaleX;
            //                textBox.set("width",tryWidth);
            // //               this.canvas.getActiveObject().set("width",tryWidth);
            //             }
         });

         textBox.on("editing:entered", function (e) {
            //canvas.setActiveObject(textBox);
            var obj = this.canvas.getActiveObject();
            console.log("entered editing, text : " +  textBox.text);
            textBox.selectAll();
            textBox.removeChars();
            if(textBox.text == "Enter Text")
            {
               //console.log("Enter Text");
               textBox.selectAll();
               textBox.removeChars();
            }
         });

         textBox.on("editing:exited", function (e) {
            console.log("exited editing");
            textBox.editable = false;
            textBox.cursorWidth = 0;
            if (textBox.text == "")
            that.delete(textBox);

         });
         //var left = arrowLeft;

         textBox.on(("changed"),function(){
            //canvas.setActiveObject(textBox);
            var actualWidth = textBox.scaleX * textBox.width;
            var largest = textBox.__lineWidths[0];
            console.log("largest " + largest);
            if (largest !== undefined )
            {
               var tryWidth = (largest + 50) * textBox.scaleX;
               textBox.set("width",tryWidth);
               //               this.canvas.getActiveObject().set("width",tryWidth);
            }
            if((textBox.left + actualWidth) >= this.canvas.width - 10)
            {
               //console.log(canvas.height - arrowLeft)
               textBox.set("width", this.canvas.width - 10)
            }
            console.log("textbox width " + textBox.width);
            canvas.renderAll();

         });
         textBox.on(("modified"),function(){
            //left = this.textBox.left;
            console.log("textbox modified");
            this.canvas.renderAll();

         });

         var canv = this.$canvas;
         // textBox.on(("mousedown"),function(){
         //    //console.log("text clicked " + this.isSelected);
         //    //this.canvas.renderAll();
         //    if (this.isSelected){
         //       this.isSelected = false;
         //       canv.discardActiveObject();
         // }
         // });

         textBox.on(("selected"),function(){
            //left = this.textBox.left;
            //console.log("text selected");
            //this.canvas.renderAll();
            var that = this;
            var timeout = setTimeout(function(){
               that.isSelected = true;
            }, 10)
            this.bringToFront();
            //this.perPixelTargetFind = false;
            //this.setShadow({ color: 'rgba(0,0,0,0.7)', blur: 50 });


         });
         textBox.on(("deselected"),function(){
            //left = this.textBox.left;
            //console.log("text deselected");
            //this.perPixelTargetFind = true;
            this.isSelected = false;
            //this.setShadow({ color: 'rgba(0,0,0,0.', blur: 50 });
            this.canvas.renderAll();
         });




      }

   }
}
